import { FC } from 'react';

import { ESHOP_TEST_ID } from '@telialt/core-eshop/src/test/test-ids';
import { Classification } from '@telialt/models/src/EshopModel';

import { TechnicalCharacteristicsAlignment } from './model';
import { TechnicalCharacteristicsGroup } from './TechnicalCharacteristicsGroup';

type Props = {
    classifications: Classification[];
    alignment?: TechnicalCharacteristicsAlignment;
};

export const TechnicalCharacteristics: FC<Props> = ({ classifications, alignment }) => {
    return (
        <div data-test={ESHOP_TEST_ID.TECHNICAL_CHARACTERISTICS}>
            {classifications.map(({ code, name, features }) => (
                <TechnicalCharacteristicsGroup key={code} title={name} features={features} alignment={alignment} />
            ))}
        </div>
    );
};
